import BooksSlider from "../../../../src/custom/books/booksSlider";
import Accordion from "../../../../src/custom/common/accordion";
import * as React from 'react';
export default {
  BooksSlider,
  Accordion,
  React
};